import React, {useState} from 'react';
import {get} from 'lodash';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import LoginForm, {LoginFormInputs} from './LoginForm';
import {usePostApi} from 'hooks/usePostApi';
import {useAuthContext} from 'context/AuthContext';
import {api} from 'api';
import {Logo} from 'components/Logo';
import {refreshCsrfOnce} from 'api/fetchCsrfToken';
import ChangePasswordDialog from './ChangePasswordDialog';
import {useModal} from 'hooks/useModal';
import {IAuthData} from 'types';

const LoginPage = () => {
   const {t} = useTranslation();

   var isIE = get(window, 'document.documentMode') ? true : false;

   const {open: changeOpened, handleOpen: openChange, handleClose: closeChange} = useModal(false);
   const [loginData, setLoginData] = useState<LoginFormInputs>();
   const {login} = useAuthContext();

   const {request} = usePostApi(api.login, {
      onSuccess(data) {
         login(data);
      },
      onFailure(error, message, errResp) {
         console.debug('error login', error, message);
         if (errResp.status === 419) {
            login({
               ...(error as IAuthData),
               auth: false,
            });
            openChange();
            return true;
         }
      },
   });

   const postLogin = async (data: LoginFormInputs) => {
      try {
         await refreshCsrfOnce();
         setLoginData(data);
         await request(JSON.stringify(data));
      } catch (e) {
         console.error('login error', e);
      }
   };

   return (
      <>
         <Box
            sx={(theme) => ({
               padding: theme.spacing(3),
               borderBottom: '5px solid #bed600',
               '& > svg': {
                  width: 200,
               },
               marginBottom: theme.spacing(5),
            })}
         >
            <Logo />
         </Box>
         {isIE ? (
            <Box
               sx={(theme) => ({
                  background: theme.palette.error.dark,
                  color: theme.palette.error.contrastText,
                  textAlign: 'center',
               })}
            >
               <Typography variant="h4">
                  {t(
                     'You are on an unsupported browser and Diplomat MFT Web Admin might not work.'
                  )}
               </Typography>
               <Typography variant="h5">
                  {t('Works with the Chrome, Firefox, Safari, or Edge browsers')}
               </Typography>
            </Box>
         ) : (
            <LoginForm onSubmit={postLogin} />
         )}
         {changeOpened && (
            <ChangePasswordDialog
               onClose={closeChange}
               data={{username: loginData?.username, fromStartup: true}}
            />
         )}
      </>
   );
};

export default LoginPage;
